export default __webpack_public_path__ + "static/media/chain-4.f4fbb51d.png";